import { shallowRef } from "vue";
import "./orderDetails";

import {
  AllChecksIcon,
  PersonCancelIcon,
  PersonCheckIcon,
  PersonOffIcon,
  PersonSearchIcon,
  RecordVoiceIcon,
  SchoolIcon,
  PersonRaisedHand,
} from "@/components/shared/icons";

export const OrderStatus = {
  DRAFT: "Draft",
  SUBMITTED: "Submitted",
  FULFILLED: "Fulfilled",
  PAID_CONFIRMED: "Paid, Confirmed",
  WITHDRAWN: "Withdrawn",
};

/**
 * Get the status label
 * @param {OrderDetail} order
 * @returns {string}
 */
export const orderStatusLabel = (order) => {
  const now = new Date();

  if ([OrderStatus.SUBMITTED, OrderStatus.FULFILLED, OrderStatus.PAID_CONFIRMED].includes(order.core.status)) {
    if (order.session.academic_end_date < now) {
      return StudentStatus.ALUMNI.label;
    } else if (order.session.academic_start_date < now) {
      return StudentStatus.ACTIVELY_PARTICIPATING.label;
    }
  }
  switch (order.core.status) {
    case OrderStatus.DRAFT:
      return StudentStatus.EXPERIENCE_EXPLORER.label;
    case OrderStatus.WITHDRAWN:
      return StudentStatus.WITHDRAWN.label;
    case OrderStatus.SUBMITTED:
      return StudentStatus.SUBMITTED.label;
    case OrderStatus.FULFILLED:
      return StudentStatus.CONFIRMED.label;
    case OrderStatus.PAID_CONFIRMED:
      return StudentStatus.CONFIRMED.label;
  }
};

export const StudentStatus = {
  INTERESTED: { label: "Interested", order: 1 },
  EXPERIENCE_EXPLORER: { label: "Explorer", order: 2 },
  SUBMITTED: { label: "Submitted", order: 3 },
  CONFIRMED: { label: "Confirmed", order: 4 },
  ACTIVELY_PARTICIPATING: { label: "Actively Participating", order: 5 },
  WITHDRAWN: { label: "Withdrawn", order: 6 },
  ALUMNI: { label: "Alumni", order: 7 },
  INACTIVE: { label: "Inactive", order: 8 },
  UNCATEGORIZED: { label: "Un-categorized", order: 9 },
};

export const getParticipantStatusLabel = (status) => {
  switch (status) {
    default:
      return status;
  }
};

export const getParticipantStatusDescription = (status) => {
  switch (status) {
    case StudentStatus.SUBMITTED.label:
      return "Application or registration completed";
    case StudentStatus.INTERESTED.label:
      return "Lead form completed or account created";
    case StudentStatus.EXPERIENCE_EXPLORER.label:
      return "Actively researching experiences";
    case StudentStatus.ALUMNI.label:
      return "Experience has been completed";
    case StudentStatus.INACTIVE.label:
      return "Student withdrew from an experience";
    case StudentStatus.ACTIVELY_PARTICIPATING.label:
      return "Actively participating in experience(s)";
    case StudentStatus.WITHDRAWN.label:
      return "Student withdrew from an experience";
    case StudentStatus.CONFIRMED.label:
      return "Confirmation payment made; enrollment accepted";
    default:
      return "";
  }
};

export const getParticipantStatusIcon = (status) => {
  switch (status) {
    case StudentStatus.SUBMITTED.label:
      return shallowRef(AllChecksIcon);
    case StudentStatus.INTERESTED.label:
      return shallowRef(PersonRaisedHand);
    case StudentStatus.EXPERIENCE_EXPLORER.label:
      return shallowRef(PersonSearchIcon);
    case StudentStatus.ALUMNI.label:
      return shallowRef(SchoolIcon);
    case StudentStatus.INACTIVE.label:
      return shallowRef(PersonOffIcon);
    case StudentStatus.ACTIVELY_PARTICIPATING.label:
      return shallowRef(RecordVoiceIcon);
    case StudentStatus.WITHDRAWN.label:
      return shallowRef(PersonCancelIcon);
    case StudentStatus.CONFIRMED.label:
      return shallowRef(PersonCheckIcon);
    default:
      return undefined;
  }
};
